// extracted by mini-css-extract-plugin
export default {"container":"DefaultLayout_container__uD+pi","default-layout":"DefaultLayout_default-layout__CuxOF","wrap":"DefaultLayout_wrap__WVjM6","wrap-child":"DefaultLayout_wrap-child__Zq0u4"};